<div class="recipient-form">
  <h5>{{ wscPrefix + '.title' | translate }}</h5>
  <p [innerHtml]="wscPrefix + '.instruction' | translate"></p>

  <!-- Hide entire navbar if there is no existing contacts -->
  <div class="recipient-nav" *ngIf="contactList?.length > 0">
    <a
      class="recipient-nav-item"
      [class.active]="currentNav === navigation.NEW_RECIPIENT"
      (click)="navigateTo(navigation.NEW_RECIPIENT)"
      >{{ wscPrefix + '.nav.new.recipient' | translate }}</a
    >
    <a
      class="recipient-nav-item"
      [class.active]="currentNav === navigation.EXISTING_CONTACTS"
      (click)="navigateTo(navigation.EXISTING_CONTACTS)"
      >{{ wscPrefix + '.nav.existing.contacts' | translate }}</a
    >
  </div>
  <div class="recipient-form-container">
    @switch (currentNav) {
      <!-- New recipient form -->
      @case (navigation.NEW_RECIPIENT) {
        <ng-container *ngTemplateOutlet="newRecipient"></ng-container>
      }
      <!-- Existing contacts -->
      @case (navigation.EXISTING_CONTACTS) {
        <ng-container *ngTemplateOutlet="existingContacts"></ng-container>
      }
    }
  </div>
  <div class="error-message" *ngIf="action.errorMessage">{{ action.errorMessage }}</div>
  <div class="action-wrapper">
    <button class="btn text-danger" (click)="onCancel.emit()">{{ wscPrefix + '.cancel.button' | translate }}</button>
    <button
      class="btn btn-success"
      (click)="submit()"
      [disabled]="currentNav === navigation.EXISTING_CONTACTS && !newRecipientForm.valid"
    >
      @if (!action.loading) {
        {{ wscPrefix + '.submit.button' | translate }}
      } @else {
        <!-- Display spinner if it's loading -->
        <fgbcl-loading size="small"></fgbcl-loading>
      }
    </button>
  </div>
</div>

<ng-template #newRecipient>
  <form class="new-recipient-form" [formGroup]="newRecipientForm">
    <div class="new-recipient-form-group">
      <div class="form-group">
        <div class="form-floating">
          <input type="text" class="form-control" formControlName="FullName" id="FullName" placeholder="Full Name" />
          <label for="FullName">{{ wscPrefix + '.form.fullname.label' | translate }}</label>
        </div>
        <div
          class="error-message"
          *ngIf="newRecipientForm.get('FullName')?.hasError('required') && newRecipientForm.get('FullName')?.touched"
        >
          {{ wscPrefix + '.fullname.error.required' | translate }}
        </div>
        <div
          class="error-message"
          *ngIf="newRecipientForm.get('FullName')?.hasError('empty') && newRecipientForm.get('FullName')?.touched"
        >
          {{ wscPrefix + '.fullname.error.empty' | translate }}
        </div>
        <div
          class="error-message"
          *ngIf="newRecipientForm.get('FullName')?.hasError('pattern') && newRecipientForm.get('FullName')?.touched"
        >
          {{ wscPrefix + '.fullname.error.pattern' | translate }}
        </div>
      </div>
      <div class="form-group">
        <div class="form-floating">
          <input type="email" class="form-control" formControlName="EmailAddress" id="EmailAddress" placeholder="Email Address" />
          <label for="EmailAddress">{{ wscPrefix + '.form.email.address.label' | translate }}</label>
        </div>
        <div
          class="error-message"
          *ngIf="newRecipientForm.get('EmailAddress')?.hasError('required') && newRecipientForm.get('EmailAddress')?.touched"
        >
          {{ wscPrefix + '.email.address.error.required' | translate }}
        </div>
        <div
          class="error-message"
          *ngIf="newRecipientForm.get('EmailAddress')?.hasError('pattern') && newRecipientForm.get('EmailAddress')?.touched"
        >
          {{ wscPrefix + '.email.address.error.pattern' | translate }}
        </div>
      </div>
    </div>
    <div class="form-check save-checkbox">
      <input class="form-check-input" formControlName="saveRecipient" type="checkbox" value="" id="flexCheckDefault" />
      <label class="form-check-label" for="flexCheckDefault">{{ wscPrefix + '.form.save.recipient.label' | translate }}</label>
    </div>
  </form>
</ng-template>
<ng-template #existingContacts>
  <form class="existing-contacts-form">
    <div class="form-floating">
      <select class="form-select" id="existingContact" aria-label="Select Contact" (change)="onChange($event.target.value)">
        <option selected value="" hidden>{{ wscPrefix + '.form.select.contact.none.selected' | translate }}</option>
        <option [value]="contact.Id" *ngFor="let contact of contactList">
          {{ contact.FullName + '(' + contact.EmailAddress + ')' }}
        </option>
      </select>
      <label for="existingContact">{{ wscPrefix + '.form.select.contact.label' | translate }}</label>
    </div>

    <div class="error-message" *ngIf="newRecipientForm.invalid && newRecipientForm.touched">
      {{ wscPrefix + '.existing.required' | translate }}
    </div>
  </form>
</ng-template>
